import { render, staticRenderFns } from "./RestCUDialog.vue?vue&type=template&id=981fe760"
import script from "./RestCUDialog.vue?vue&type=script&lang=js"
export * from "./RestCUDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports